module.exports = __webpack_public_path__ + "static/media/icon3.659ac3e3.png";